import { CDN_URL } from "@/config/constants";
import QueryString from "qs";
import { To } from "react-router-dom";
import { SelectOption } from "rizzui";
export function validUrl(url: string) {
  if (!url) return url;
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
}
export function convertUrl(url?: string) {
  if (!url) return url;
  const isValid = validUrl(url);
  if (isValid) {
    // The url is include cdn url right now
    return url;
  } else {
    // The url is not include cdn url
    return `${CDN_URL}${url}`;
  }
}

export function getParamsCurrentPage(
  extraParams?: Record<string, any>
): string {
  const searchParamsParse = QueryString.parse(location?.search.slice(1));
  const queryParams = {
    backTo: {
      pathname: location.pathname,
      ...searchParamsParse,
      rowKey: extraParams?.rowKey,
    },
    ...extraParams,
  };

  return QueryString.stringify(queryParams);
}

interface IBackTo {
  pathname?: string;
  page?: number;
  limit?: number;
  search?: string;
  rowKey?: string;
  backTo?: IBackTo;
}
export function backPrev(fallback?: string): To {
  const searchParamsParse: {
    backTo?: IBackTo;
  } = QueryString.parse(location?.search.slice(1));

  return {
    pathname: searchParamsParse?.backTo?.pathname || fallback,
    search: QueryString.stringify({
      page: searchParamsParse?.backTo?.page || 1,
      limit: searchParamsParse?.backTo?.limit || 10,
      rowKey: searchParamsParse?.backTo?.rowKey || "",
      search: searchParamsParse?.backTo?.search || "",
      backTo: { ...searchParamsParse?.backTo?.backTo },
    }),
  };
}

// Calculate monthly price
export const calculateMonthlyPrice = (
  price: number,
  duration: number | undefined
): number => {
  if (!duration || duration === 0) return price;
  return price / (duration / 30);
};

export const openContactWhatsApp = (
  phone: string | undefined,
  content: string
) => {
  if (!phone) return;
  const encodedMessage = encodeURIComponent(content);
  const whatsappUrl = `https://api.whatsapp.com/send/?phone=${phone}&text=${encodedMessage}&type=phone_number&app_absent=0`;

  // Use window.open directly which works better on iOS Safari
  window.open(whatsappUrl, "_blank", "noopener,noreferrer");
};

export const transformNestedObjectToObject = (
  obj: Record<string, any>,
  prefix = ""
): Record<string, any> => {
  return Object.keys(obj).reduce(
    (acc, key) => {
      const pre = prefix.length ? prefix + "." : "";
      if (
        typeof obj[key] === "object" &&
        obj[key] !== null &&
        !Array.isArray(obj[key])
      ) {
        Object.assign(acc, transformNestedObjectToObject(obj[key], pre + key));
      } else {
        acc[pre + key] = obj[key];
      }
      return acc;
    },
    {} as Record<string, unknown>
  );
};

export function formatDuration(days: number) {
  if (typeof days !== "number" || days < 0) {
    return "Invalid duration";
  }

  if (days < 30) {
    return `${days} ${days === 1 ? "day" : "days"}`;
  }

  const months = days / 30;
  const roundedMonths = Math.round(months * 10) / 10; // round to 1 decimal place
  return `${roundedMonths} ${roundedMonths === 1 ? "month" : "months"}`;
}

export function sortSelectOptionsAZ<T extends { label: string }>(
  options: T[]
): T[] {
  return options.sort((a, b) => a.label.localeCompare(b.label));
}
